import { MotionNodeAnimationOptions } from 'motion/react';
import { useDeviceType } from '../context/DeviceTypeProvider';

/**
 * Custom hook to apply animation properties based on device type.
 */
export const useMobileAnimation = (
  animationProps: MotionNodeAnimationOptions,
) => {
  const { isMobile } = useDeviceType();

  return isMobile ? null : animationProps;
};
